import type { SVGProps } from "react";
export const KeyboardArrowRight = (props: SVGProps<SVGSVGElement>) => (
	<svg
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		aria-hidden={true}
		{...props}
	>
		<path
			d="M12.9462 12L8.34619 7.4L9.39994 6.34625L15.0537 12L9.39994 17.6538L8.34619 16.6L12.9462 12Z"
			fill="currentColor"
		/>
	</svg>
);
